var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Basic',{attrs:{"IsPembayaran":true,"IsPaymentSettled":_vm.IsPaymentSettled}}),_c('SuratPenunjangList',{staticClass:"mt-4",attrs:{"IsPembayaran":true,"IsPaymentSettled":_vm.IsPaymentSettled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }